// For more information on photoswipe see: http://photoswipe.com
// Most of this JS is copied from:
// http://photoswipe.com/documentation/getting-started.html
// We have just one gallery/page and a bit different HTML structure

import PhotoSwipe from 'photoswipe'
import PhotoSwipeUi from 'photoswipe/dist/photoswipe-ui-default'

const srcImages = document.getElementsByClassName('js-pswp-image')

const collectImages = function() {
  const galleryData = []

  for (let i = 0; i < srcImages.length; ++i) {
    const imageData = {
      src: srcImages[i].getAttribute('href'),
      w: srcImages[i].getAttribute('data-pswp-width'),
      h: srcImages[i].getAttribute('data-pswp-height'),
      bu: srcImages[i].getAttribute('data-pswp-bu'),
      source: srcImages[i].getAttribute('data-pswp-source'),
      camera: srcImages[i].getAttribute('data-pswp-camera'),
    }
    galleryData.push(imageData)
  }

  return galleryData
}

const closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn))
}

const onClick = function(e) {
  e = e || window.event
  e.preventDefault ? e.preventDefault() : e.returnValue = false

  const eTarget = e.target || e.srcElement

  const clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'A')
  })

  let index = clickedListItem.getAttribute('data-pswp-uid')
  index--

  if (index >= 0) {
    openPhotoSwipe(index)
  }
  return false
}

const photoswipeParseHash = function() {
  const hash = window.location.hash.substring(1)
  const params = {}

  if (hash.length < 5) {
    return params
  }

  const vars = hash.split('&')
  for (let i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue
    }
    const pair = vars[i].split('=')
    if (pair.length < 2) {
      continue
    }
    params[pair[0]] = pair[1]
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10)
  }

  return params
}

const openPhotoSwipe = function(index, disableAnimation, fromURL) {
  const pswpElement = document.querySelectorAll('.pswp')[0]

  const items = collectImages()

  const options = {
    index,
    getThumbBoundsFn: function(index) {
      const thumbnail = srcImages[index].getElementsByTagName('img')[0]
      const pageYScroll = window.pageYOffset || document.documentElement.scrollTop
      const rect = thumbnail.getBoundingClientRect()

      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
    },
    addCaptionHTMLFn: function(item, captionEl) {
      if (!item.bu && !item.source) {
        return false
      }

      item.title = true

      // always reset the inner html
      captionEl.children[0].innerHTML = '<p class="pswp__caption-bu">'

      if (item.bu) {
        captionEl.children[0].innerHTML += item.bu
      }

      if (item.source) {
        captionEl.children[0].innerHTML +=
          '<br><small class="pswp__caption-source">' +
          item.source +
          '</small>'
      }

      captionEl.children[0].innerHTML += '</p>'

      if (item.camera) {
        captionEl.children[0].innerHTML +=
        '<p class="pswp__caption-camera">' +
        item.camera +
        '</p>'
      }

      return true
    },
  }

  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (let j = 0; j < items.length; j++) {
        if (items[j].pid === index) {
          options.index = j
          break
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1
    }
  } else {
    options.index = parseInt(index, 10)
  }

  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUi, items, options)
  gallery.init()
}

for (let i = 0, l = srcImages.length; i < l; i++) {
  srcImages[i].setAttribute('data-pswp-uid', i + 1)
  srcImages[i].onclick = onClick
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
const hashData = photoswipeParseHash()
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, true, true)
}
